import { match as Match } from "react-router-dom";
import { Card, CardBody, CardHeader } from '../../../_metronic/_partials/controls';
import { ProductCatalogWidget } from '../components/ProductCatalogWidget';

type Props = {
  cardProps?: any;
  match: Match<IRouteParams>;
}

interface IRouteParams {
  productCode: string;
}

const ProductCatalogByProductPage = ({ cardProps, match }: Props) => {
  return (
    <Card {...cardProps}>
      <CardHeader
        className='border-0'
        title={`Product Catalog - ${match.params.productCode}`}
        {...cardProps}
      />
      <CardBody {...cardProps}>
        <ProductCatalogWidget productCode={match.params.productCode} />
      </CardBody>
    </Card>
  );
};

export { ProductCatalogByProductPage };
